export const isSameDateRange = (value, defaultDates) => {
  if (
    !Array.isArray(value) ||
    !Array.isArray(defaultDates) ||
    value.length !== 2 ||
    defaultDates.length !== 2
  ) {
    return false
  }

  return (
    value[0].isSame(defaultDates[0], 'day') &&
    value[1].isSame(defaultDates[1], 'day')
  )
}
